var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.OfferItem.discountPct > 0)?_c('span',{staticClass:"discount d-inline-block discount font-1"},[_vm._v(" "+_vm._s(_vm.OfferItem.discountPct)+"% OFF ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }